import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class ImageContent extends React.PureComponent<ImageContent.Props, ImageContent.State> {
  public static sectionId = 'imageco';

  public constructor(props) {

    super(props)

    const isDesktop = window.innerWidth > 960

    this.state = {
      hovered: false,
      isDesktop: isDesktop
    }
    
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.setState({
          isDesktop: window.innerWidth > 960
        })
      })
    }
  }

    
  public render(): JSX.Element {
    const { section, location } = this.props
    const { article } = this.props.data.section

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = article?.settings?.allow_full_width_images

    const { settings, blocks } = section
    if (!settings) {
      return <React.Fragment />
    }

    const {
      imagetopmobile,
      imagebetweentitleandcontent,
      productctaname,
      productctalinktext,
      productctalinkurl,
      mobilecontentpadding,
      linkToAnchor,
      anchorHandle
    } = settings

    let { fontfamily } = settings
    
    if (fontfamily === 'auto') {
      fontfamily = ''
    }

    const ctaReady = productctaname && productctalinkurl && productctalinktext
    const alignWithFooter = settings.maxwidth == 'Align with Footer' ? 'max-w-container mx-1-6 sm:mx-2-4 xl:mx-3 md:mx-2-8' : settings.maxwidth == 'Contained' ? 'max-w-6xl mx-auto' : 'max-w-full'
    const imageWidth = settings.imageratio == '16:10' ? 'md:w-7/12' : 'md:w-1/2'
    const contentWidth = settings.imageratio == '16:10' ? 'md:w-4/12' : 'md:w-1/2'

    const ctaOnHover = <div 
      style={{
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255,255,255,0.45)',
      }}
      className={`
        absolute z-20 w-full bottom-0 left-0 
        transform transition-transform duration-300
        ${(this.state.hovered && this.state.isDesktop) ? 'translate-y-0' : 'translate-y-full'}
      `}
    >
      {ctaReady && (
        <div className={'py-1 px-1-3'}>
          <span className={'font-bold text-sm'}>{ productctaname }</span>
          <span className={'ml-1 text-sm'}>
            <Snippets.Link
              className={'underline'}
              title={productctalinktext}
              href={productctalinkurl}
            >{ productctalinktext }</Snippets.Link>
          </span>
        </div>
      )}
    </div>

    let mobileContentPadding = ''
    switch (mobilecontentpadding) {
    case '2':
      mobileContentPadding = 'py-2 px-2'
      break
    case '4':
      mobileContentPadding = 'py-4 px-4'
      break
    case '6':
      mobileContentPadding = 'py-6 px-4'
      break
    case '8':
      mobileContentPadding = 'py-8 px-4'
      break
    case '10':
      mobileContentPadding = 'py-10 px-4'
      break
    case '12':
      mobileContentPadding = 'py-12 px-4'
      break
    case '14':
      mobileContentPadding = 'py-14 px-4'
      break
    case '16':
      mobileContentPadding = 'py-16 px-4'
      break
    case '18':
      mobileContentPadding = 'py-18 px-4'
      break
    case '20':
      mobileContentPadding = 'py-20 px-4'
      break
    case '22':
      mobileContentPadding = 'py-22 px-4'
      break
    case '24':
      mobileContentPadding = 'py-24 px-4'
      break
    default:
      mobileContentPadding = 'py-2 px-2'
      break
    }

    const responsiveImage = () => {
      return (
        <>
          <Snippets.Image
            alt={settings.title || 'featured image content'}
            className={'bg-cover bg-center hidden md:block inset-0 h-full'}
            ratio={`${settings.imageratio ? settings.imageratio: '5:6'}`}
            src={settings.image}
          />
          <Snippets.Image
            alt={settings.title || 'featured image content'}
            className={'bg-cover bg-center block md:hidden inset-0 h-full'}
            ratio={'natural'}
            src={settings.imagemobile}
          />
        </>
      )
    }

    const imageContent = () => {
      return (
        <div className="relative overflow-hidden">
          {responsiveImage()}
          {ctaReady && (
            <div className={'overflow-hidden w-full flex items-start max-w-2xl mx-auto py-1 px-1 block md:hidden'}>
              <span className={'font-bold text-sm'}>{ productctaname }</span>
              <span className={'ml-0-8 text-sm'}>
                <Snippets.Link
                  className={'underline'}
                  title={productctalinktext}
                  href={productctalinkurl}
                >{ productctalinktext }</Snippets.Link>
              </span>
            </div>
          )}
          {ctaOnHover}
        </div>
      ) 
    }
    
    let contentAlignmentClass = 'items-center'
    switch (settings.contentalignment) {
    case 'top':
      contentAlignmentClass = 'items-start'
      break
    case 'center':
      break
    case 'bottom':
      contentAlignmentClass = 'items-end'
      break
    }

    const imageSection = (mobile) => {

      let visibility = 'flex'
      if (imagebetweentitleandcontent) {
        if (mobile) {
          visibility = 'flex md:hidden'
        } else {
          visibility = 'hidden md:flex'
        }
      } else {
        if (mobile) {
          visibility = 'hidden'
        } else {
          visibility = 'flex'
        }
      }

      return (
        <>
          {settings && settings.imageurl
            ? <Snippets.Link
              href={settings.imageurl}
              title={settings.title}
              className={`
                w-full block flex-col 
                ${visibility}
                ${imageWidth} ${imagetopmobile && 'pb-3'} relative ${settings.removetopbottompadding ? null : 'pt-3-2'}
              `}
              onMouseEnter={() => this.setState({ hovered: true })}
              onMouseLeave={() => this.setState({ hovered: false })}
            >
              {imageContent()}
            </Snippets.Link>
            : (
              <div 
                onMouseEnter={() => this.setState({ hovered: true })}
                onMouseLeave={() => this.setState({ hovered: false })}
                className={`
                  w-full overflow-hidden
                  ${visibility}
                  ${imageWidth}  ${imagetopmobile && 'pb-3'} flex flex-col relative ${settings.removetopbottompadding ? null : 'pt-3-2 md:pt-0'}
                `}
              >
                {imageContent()}
              </div>
            )
          }
        </>
      )
    }

    return (
      <section className={`dynamic-image-content ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}>
        <div className={`
          ${settings.imageratio === '2:3' ? 'max-w-9xl': !alignWithFooter ? 'max-w-8xl sm:px-2-4 3xl:px-22 xl:px-2-8' : ''} 
          ${alignWithFooter ? alignWithFooter : 'px-1-6 mx-auto'} 
          ${settings.removetopbottompadding ? null : 'py-3-2 lg:py-6-4'}
          ${location.pathname.includes('40th-birthday') ? 'px-1-5' : ''}
          ${settings.backgroundColor ? 'bg-core-pale' : ''}
        `}>
          <div className={`flex flex-wrap overflow-hidden ${imagetopmobile ? 'flex-col' : 'flex-col-reverse'} ${settings.position == 'right' ? 'md:flex-row-reverse md:justify-between' : 'md:flex-row'}`}>
            {imageSection(false)}
            <div 
              className={`
                w-full ${contentWidth} ${mobileContentPadding} 
                ${location.pathname.includes('40th-birthday') ? 'md:p-2-9' : settings.removetopbottompadding ? 'md:p-8' : 'md:p-4'} 
                flex 
                ${contentAlignmentClass}
                ${settings.removetopbottompadding ? null : `${settings && settings.position == 'left' ? 'lg:pl-12-8' : 'lg:pr-12-8'}`}
              `}
            >
              <div className={settings?.alignheadingtotop ? 'md:flex flex-col items-start md:h-full' : null}>
                <Snippets.Heading
                  tag={settings.headingstyle && settings.headingstyle !== 'uppercase' ? settings.headingstyle : 'h5'}
                  className={`text-${settings?.contentalignmentHorizontalMobile}  md:text-${settings?.contentalignmentHorizontal} ${settings.pretitleColor ? 'text-grey-dark mb-2' : ''} ${location.pathname.includes('40th-birthday') ? imagebetweentitleandcontent ? 'md:mb-0-8 mb-1' : 'md:mb-0-8 mb-16' : `${settings.headingstyle === 'uppercase' ? 'mb-2' : 'mb-3-2'}`} leading-none`}
                >
                  {settings.title}
                </Snippets.Heading>

                {settings.subtitle ? 
                  <Snippets.Heading
                    tag={'h2'}
                    className={`mb-1-5 text-${settings?.contentalignmentHorizontalMobile} md:text-${settings?.contentalignmentHorizontal} ${settings.subtitleFontStyle ? `font-${settings.subtitleFontStyle}` : 'font-bold'}`}
                    size={`${settings.subtitleSize === 'large' ? 'h1' : 'h2'}`}
                  >
                    {settings.subtitle}
                  </Snippets.Heading>: null}

                {imageSection(true)}

                {settings.content ?
                  <div className={settings?.contentalignment === 'center' ? 'mt-auto mb-auto' : settings?.alignheadingtotop ? 'mt-auto' : null}>
                    <Snippets.RichText className={`rte leading-normal text-${settings?.contentalignmentHorizontalMobile} md:text-${settings?.contentalignmentHorizontal} ${settings?.alignheadingtotop ? 'mt-auto' : null} ${fontfamily ? `font-${fontfamily == 'serif' ? 'mono' : fontfamily}` : null} ${fontfamily == 'serif' ? 'leading-none' : null}`}>
                      {this.state.isDesktop || !settings.contentmobile ? settings.content : settings.contentmobile}
                    </Snippets.RichText>
                  </div>
                  : null}

                {settings.linktext ? (
                  <Snippets.Button
                    onClick={(e) => {
                      if (linkToAnchor) {
                        e.preventDefault()
                        const anchor = document.getElementById(anchorHandle)
                        
                        scroll({
                          top: anchor.offsetTop,
                          behavior: 'smooth'
                        })
                        
                        return
                      }
                      
                      trackPromotionClick(
                        [{
                          id: section.id,
                          name: settings.title,
                          creative: 'Image content'
                        }],
                        settings.linkurl
                      )}}
                    className={`w-full text-${settings?.CTAalignmentHorizontalMobile} md:text-${settings?.CTAalignmentHorizontal} uppercase tracking-wide mt-2 ${settings.ctaUnderline ? 'underline underline-offset-8 cta-underline' : ''}`}
                    title={settings.linktext}
                    colour={`${settings.ctaUnderline ? 'link' : 'secondary'}`}
                  >
                    {settings.linktext}
                  </Snippets.Button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export namespace ImageContent {
  export type Options = ShopifyNext.Section<{
    title: any;
    titlefont: string;
    alignheadingtotop: boolean;
    subtitle: string;
    subtitleSize: string;
    subtitleFontStyle: string;
    fullwidth: boolean;
    background: string;
    position: string;
    colour: string;
    image: string;
    imagemobile: string;
    imageurl: string;
    content: string;
    contentmobile: string;
    linktext: string;
    linkurl: string;
    imageratio: string;
    headingstyle: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'uppercase';
    maxwidth: string;
    imagebetweentitleandcontent: boolean;
    removetopbottompadding: boolean;
    contentalignment?: string;
    contentalignmentHorizontal?: string;
    contentalignmentHorizontalMobile?: string;
    CTAalignmentHorizontal?: string;
    CTAalignmentHorizontalMobile?: string;
    fontfamily?: string;
    imagetopmobile: boolean;
    productctaname: string;
    productctalinktext: string;
    productctalinkurl: string;
    mobilecontentpadding: string;
    backgroundColor: boolean;
    pretitleColor: boolean;
    ctaUnderline: boolean;
    linkToAnchor: boolean;
    anchorHandle: string;
  }>;
  export interface Props extends GlobalProps {
    section: ImageContent.Options;
    location: any;
  }
  export interface State { 
    hovered: boolean;
    isDesktop: boolean;
  }
}
